import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronLeft,
	faChevronRight,
	faUserTie, // Add this icon for substitute mode
} from "@fortawesome/free-solid-svg-icons";
import { ToggleSwitch } from "../../../../components/common/";
import styles from "./LogsHeader.module.css";

const LogsHeader = ({
	weekRange,
	isCurrentWeek,
	canNavigateNext,
	onPreviousWeek,
	onNextWeek,
	onCurrentWeek,
	departments,
	selectedDepartment,
	onDepartmentChange,
	isMobile,
	weekdays,
	selectedDayIndex,
	onDayChange,
	isSubstituteMode,
	onSubstituteModeToggle,
}) => {
	// FIX: Handle the toggle change properly
	const handleSubstituteToggle = (e) => {
		onSubstituteModeToggle(e.target.checked);
	};

	return (
		<div className={styles.header}>
			<div className={styles.headerLeft}>
				{!isMobile && <h2 className={styles.title}>Class Logs</h2>}
				<div className={styles.weekSelector}>
					<button
						className={styles.navButton}
						onClick={onPreviousWeek}
						aria-label="Previous week"
					>
						<FontAwesomeIcon icon={faChevronLeft} />
					</button>

					<span className={styles.weekRange}>{weekRange}</span>

					<button
						className={`${styles.navButton} ${
							!canNavigateNext ? styles.disabled : ""
						}`}
						onClick={onNextWeek}
						disabled={!canNavigateNext}
						aria-label="Next week"
					>
						<FontAwesomeIcon icon={faChevronRight} />
					</button>

					{!isCurrentWeek && (
						<button className={styles.todayButton} onClick={onCurrentWeek}>
							Today
						</button>
					)}
				</div>
			</div>

			<div className={styles.headerRight}>
				<div className={styles.substituteToggle}>
					<FontAwesomeIcon icon={faUserTie} className={styles.substituteIcon} />
					<ToggleSwitch
						checked={isSubstituteMode}
						onChange={handleSubstituteToggle}
						label={isMobile ? "" : "Substitute"}
						variant={isSubstituteMode ? "primary" : "default"}
					/>
				</div>

				<select
					className={styles.departmentSelect}
					value={selectedDepartment}
					onChange={(e) => onDepartmentChange(e.target.value)}
					aria-label="Select department"
				>
					{departments.map((dept) => (
						<option key={dept.id} value={dept.id}>
							{dept.departmentName}
						</option>
					))}
				</select>

				{isMobile && (
					<select
						className={styles.daySelect}
						value={selectedDayIndex}
						onChange={(e) => onDayChange(Number(e.target.value))}
						aria-label="Select day"
					>
						{weekdays.map((day, idx) => (
							<option key={day.dateFormatted} value={idx}>
								{day.name} {day.isToday ? "(Today)" : ""}
							</option>
						))}
					</select>
				)}
			</div>
		</div>
	);
};

export default LogsHeader;
